// Typelizer digest 6496e2bbf3cc31c2ae169781822cf4a3
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /companies/:id/archive */
  create: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/companies/:id/archive', params, options),
    method: 'post',
  }),
}
